import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { Empty } from 'antd';
import moment from 'moment';
import styled from 'styled-components';
import { Box, Flex, Text } from 'atoms';

const Container = styled(Box)`
	max-width: 1000px;
	margin: 0 auto;
	padding: 24px;
`;
const Card = styled(Box)`
	background: #fff;
	border: 1px solid #e8e8e8;
	border-radius: 8px;
	padding: 24px;
	margin-bottom: 16px;
`;
const Grid = styled(Box)`
	display: grid;
	grid-template-columns: repeat(2, 1fr);
	gap: 16px 40px;
`;
const Label = styled(Text)`
	font-size: 12px;
	color: #666;
	display: block;
`;
const Value = styled(Text)`
	font-size: 15px;
	font-weight: 600;
	color: #000;
	display: block;
`;

const formatCurrency = (value) => {
	if (value == null || value === '') return '-';
	const num = Number(value);
	return Number.isNaN(num) ? value : `₹ ${num.toLocaleString('en-IN')}`;
};
const formatDateTime = (v) => (v ? moment(v).format('DD-MM-YYYY HH:mm') : '-');

/**
 * Read-only detail of a client invoice regeneration request. Data is passed via
 * router state from the approvals list (no dedicated detail endpoint needed).
 */
function ClientInvoiceRegenApprovalDetailsPageV2() {
	const navigate = useNavigate();
	const { state } = useLocation();
	const record = state?.request;

	return (
		<Container>
			<Flex alignItems="center" gap="12px" mb={3}>
				<ArrowLeftOutlined
					style={{ cursor: 'pointer' }}
					onClick={() => navigate('/approvals/client-invoice-edit-approval')}
				/>
				<Text style={{ fontSize: 20, fontWeight: 600 }}>Regeneration Request</Text>
			</Flex>

			{!record ? (
				<Empty description="Request details unavailable. Open from the approvals list." />
			) : (
				<>
					<Card>
						<Grid>
							<Box>
								<Label>Invoice No</Label>
								<Value>{record.invoice_no || '-'}</Value>
							</Box>
							<Box>
								<Label>Status</Label>
								<Value>{record.approval_status || '-'}</Value>
							</Box>
							<Box>
								<Label>Client</Label>
								<Value>{record.client || '-'}</Value>
							</Box>
							<Box>
								<Label>Project</Label>
								<Value>{record.project || '-'}</Value>
							</Box>
							<Box>
								<Label>Billing Period</Label>
								<Value>{record.billing_period || '-'}</Value>
							</Box>
							<Box>
								<Label>Requested By</Label>
								<Value>{record.requested_by || '-'}</Value>
							</Box>
							<Box>
								<Label>Requested At</Label>
								<Value>{formatDateTime(record.requested_at)}</Value>
							</Box>
						</Grid>
					</Card>

					<Card>
						<Text
							style={{
								fontSize: 16,
								fontWeight: 600,
								display: 'block',
								marginBottom: 16,
							}}
						>
							Amount Comparison
						</Text>
						<Grid>
							<Box>
								<Label>Initial Invoice Value</Label>
								<Value>{formatCurrency(record.initial_invoice_value)}</Value>
							</Box>
							<Box>
								<Label>Updated Invoice Value</Label>
								<Value>{formatCurrency(record.updated_invoice_value)}</Value>
							</Box>
						</Grid>
					</Card>

					{(record.reason || record.rejection_reason) && (
						<Card>
							{record.reason && (
								<Box mb={2}>
									<Label>Reason</Label>
									<Value>{record.reason}</Value>
								</Box>
							)}
							{record.rejection_reason && (
								<Box>
									<Label>Rejection Reason</Label>
									<Value>{record.rejection_reason}</Value>
								</Box>
							)}
						</Card>
					)}
				</>
			)}
		</Container>
	);
}

export default ClientInvoiceRegenApprovalDetailsPageV2;
